interface CookieOptionsInterface {
    expiresDays: number;
    path?: string;
    domain?: string;
    secure?: boolean;
}

export function setCookie(key: string, value: string, options?: CookieOptionsInterface): void {
    if (value) {
        let cookieOptions: string[] = [];

        if (options) {
            const date = options.expiresDays ? new Date(new Date().getTime() + 864e+5 * options.expiresDays) : new Date();
            cookieOptions = [
                options.expiresDays ? `; expires=${date}` : '', // use expires attribute, max-age is not supported by IE
                options.path ? `; path=${options.path}` : '',
                options.domain ? `; domain=${options.domain}` : '',
                options.secure ? '; secure' : ''
            ];
        }

        document.cookie = [
            encodeURIComponent(key),
            '=',
            encodeURIComponent(value),
            ...cookieOptions
        ].join('');
    }
}

export function getCookie(key: string): string | null | undefined {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${encodeURIComponent(key)}=`);

    return parts.length === 2 ? decodeURIComponent(parts.pop()?.split(';').shift() || '') : null;
}

export function removeCookie(key: string): boolean {
    if (getCookie(key)) {
        const domain = `.${document.location.host.split('.').slice(-2).join('.')}`;
        document.cookie = `${encodeURIComponent(key)}=deleted; expires = Thu, 01 Jan 1970 00:00:00 GMT; domain = ${domain}; path = /;`;

        return true;
    }

    return false;
}
